import { AUTH_ENDPOINTS } from './Public/_Auth/_MODULES/_API';
import { PORTFOLIO_PUBLIC_ENDPOINTS } from './Public/_Portfolio/_MODULES/_API';
import { PORTFOLIO_ADMIN_ENDPOINTS } from './Private/_Shared/_MODULES/PortfolioAdminApi';
import { EMAIL_ADMIN_ENDPOINTS } from './Private/_Email/_MODULES/_API';
import { SECURITY_ADMIN_ENDPOINTS } from './Private/_Shared/_MODULES/SecurityApi';
import { SALES_PUBLIC_ENDPOINTS } from './Public/_Portfolio/_MODULES/SalesApi';
import { QUOTE_PUBLIC_ENDPOINTS } from './Public/_Portfolio/_MODULES/QuoteApi';
import { SALE_PROJECTS_ADMIN_ENDPOINTS } from './Private/_SaleProjects/_MODULES/_API';
import { QUOTES_ADMIN_ENDPOINTS } from './Private/_Quotes/_MODULES/_API';

export const API_LOAD_ENDPOINTS = {
    ...AUTH_ENDPOINTS,
    ...PORTFOLIO_PUBLIC_ENDPOINTS,
    ...PORTFOLIO_ADMIN_ENDPOINTS,
    ...EMAIL_ADMIN_ENDPOINTS,
    ...SECURITY_ADMIN_ENDPOINTS,
    ...SALES_PUBLIC_ENDPOINTS,
    ...QUOTE_PUBLIC_ENDPOINTS,
    ...SALE_PROJECTS_ADMIN_ENDPOINTS,
    ...QUOTES_ADMIN_ENDPOINTS,
};
